import { render } from "./CardResourcesComponent.vue?vue&type=template&id=44dd0dca&scoped=true"
import script from "./CardResourcesComponent.vue?vue&type=script&lang=js"
export * from "./CardResourcesComponent.vue?vue&type=script&lang=js"

import "./CardResourcesComponent.vue?vue&type=style&index=0&id=44dd0dca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44dd0dca"]])

export default __exports__